<template>
  <LSection>
    <div v-if="pending$">loading...</div>
    <div v-else class="Alert Alert--warning">
      <span>You don't have permission to view this Application.
        <br>It could be deleted or belong to another account.</span>
    </div>
  </LSection>
</template>
<script>
import Identity from 'store/identity.entity';
import Apps from 'store/apps.resource';
import Advers from 'store/advertisers.resource';

export default {
  computed: {
    pending$: () => (Identity.state.meta.pending && !Identity.state.meta.refreshing)
        || Apps.state.meta.pending
        || Advers.state.meta.pending,
  },
};

</script>